// File Metadata:
// Filename: MedicalStatusCard.js
// Version: 1.00
// Created: 2025-03-28 19:47:05
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { useState } from 'react'
import { 
    Paper, Typography, Box, Chip, 
    List, ListItem, ListItemText,
    Button, Dialog
} from '@mui/material'
import { Health, Warning, CheckCircle } from '@mui/icons-material'
import ScheduleCheckupDialog from './ScheduleCheckupDialog'

const MedicalStatusCard = ({ userId }) => {
    const [dialogOpen, setDialogOpen] = useState(false)

    return (
        <Paper sx={{ p: 2 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6">Medical Status</Typography>
                <Chip 
                    label="Valid"
                    color="success"
                    icon={<CheckCircle />}
                />
            </Box>

            <List dense>
                <ListItem>
                    <ListItemText 
                        primary="Last Checkup"
                        secondary="2023-10-01"
                    />
                </ListItem>
                <ListItem>
                    <ListItemText 
                        primary="Next Due"
                        secondary="2024-10-01"
                    />
                </ListItem>
            </List>

            <Button 
                fullWidth 
                variant="contained"
                onClick={() => setDialogOpen(true)}
            >
                Schedule Checkup
            </Button>

            <ScheduleCheckupDialog 
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                userId={userId}
            />
        </Paper>
    )
}

export default MedicalStatusCard
